// extracted by mini-css-extract-plugin
export var divider = "_rf-0";
export var systemMessage = "_rf-1";
export var systemMessageWrapper = "_rf-2";